import React from "react"
import { Redirect, Route, Switch, withRouter } from "react-router-dom"
import { AboutYouIntro } from "./AboutYouIntro"
import { AboutYouAddress } from "./AboutYouAddress"
import { AboutYouDateOfBirth } from "./AboutYouDateOfBirth"
import { AboutYouSex } from "./AboutYouSex"
import { GenderIdentity } from "./AboutYouGenderIdentity"
import useAboutYou from "../hooks/useAboutYou"
import { useAboutYouFlowControls } from "../context/AboutYouFlowContext"
import { FleLoading } from "../FleLoading"

const AboutYou = () => {
  const { isLoading, data, hasQuestionBeenSkipped } = useAboutYou()
  const { wentBack } = useAboutYouFlowControls()
  const lastStepProps = (() => {
    if (!wentBack && data?.partnerFirstName) {
      return {
        next: "/carrot-plans/partner/name"
      }
    }
    if (!wentBack && hasQuestionBeenSkipped("partnerSection")) {
      // partnerSection is only maintained in the skip table.
      // This is a workaround so we don't need to save a column for the
      // about your partner section
      return {
        next: "/carrot-plans/partner/intro"
      }
    }
    return { next: "/carrot-plans/partner/intro" }
  })()
  return (
    <Switch>
      {isLoading && <FleLoading />}
      <Route exact path="/carrot-plans/about-you">
        <Redirect to="/carrot-plans/about-you/intro" />
      </Route>
      <Route exact path="/carrot-plans/about-you/intro">
        <AboutYouIntro next="/carrot-plans/about-you/date-of-birth" />
      </Route>
      <Route exact path="/carrot-plans/about-you/date-of-birth">
        <AboutYouDateOfBirth next="/carrot-plans/about-you/sex" previous="/carrot-plans/about-you/intro" />
      </Route>
      <Route exact path="/carrot-plans/about-you/sex">
        <AboutYouSex next="/carrot-plans/about-you/gender-identity" previous="/carrot-plans/about-you/date-of-birth" />
      </Route>
      <Route exact path="/carrot-plans/about-you/gender-identity">
        <GenderIdentity next="/carrot-plans/about-you/address" previous="/carrot-plans/about-you/sex" />
      </Route>
      <Route exact path="/carrot-plans/about-you/address">
        <AboutYouAddress {...lastStepProps} previous="/carrot-plans/about-you/gender-identity" />
      </Route>
    </Switch>
  )
}

export default withRouter(AboutYou)
